// extracted by mini-css-extract-plugin
export default {"container":"LandingPage_container__i36nV","rightContainer":"LandingPage_rightContainer__bwxgg","content":"LandingPage_content__ru5II"};